import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import IconChevronRight from "@amzn/stencil-react-icons/icons/icon-chevron-right";
import { IconSize } from "@amzn/stencil-react-icons/icons/interfaces";
import { Link, LinkTextDecorationOptions } from "@amzn/uxm-stencil-react-components/lib/src/stencil/link";
import React from "react";
import { useHistory } from "react-router-dom";

interface HardwareLinkProps {
  text: string;
  link: string;
  icon: React.JSX.Element;
  description?: string;
  internalNav?: boolean;
  touchpointId: string;
}

const HardwareLink = (props: HardwareLinkProps): React.JSX.Element => {
  const history = useHistory();

  const onClick = (event: any) => {
    event.preventDefault();
    if (props.internalNav) {
      history.push(props.link);
    } else {
      window.open(props.link, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Col data-test-id="hardware-support-link">
      <Link
        href={props.link}
        touchpoint={props.touchpointId}
        onClick={onClick}
        textDecoration={LinkTextDecorationOptions.None}
        color="neutral90"
      >
        <Row
          gridGap="S200"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          padding={{ top: "S250", bottom: "S250", left: "S200", right: "S200" }}
        >
          <Row display="flex" alignItems="center" gridGap="S200">
            {props.icon}
            <Text color="neutral90" fontWeight={"medium"} fontSize={"T200"}>
              {props.text}
            </Text>
          </Row>
          <IconChevronRight color="neutral90" size={IconSize.Small} />
        </Row>
        {props.description && (
          <Row padding={{ left: 40, right: 40 }}>
            <Text color={"neutral70"} fontSize={"T100"} fontWeight={"regular"}>
              {props.description}
            </Text>
          </Row>
        )}
      </Link>
    </Col>
  );
};

export default HardwareLink;
